import { useState, useRef, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import {
  createDraftJob,
  fetchDocumentSections,
} from "../services/draftApi";
import "../styles/DraftCreator.css";

const DraftCreator = ({ onClose, onCreate, onJobCreated }) => {
  const navigate = useNavigate();

  const inputRef = useRef();
  const templateRef = useRef();
  const outputRef = useRef();

  const [inputFile, setInputFile] = useState(null);
  const [templateFile, setTemplateFile] = useState(null);
  const [outputFolder, setOutputFolder] = useState(null);

  const [inputPath, setInputPath] = useState("");
  const [templatePath, setTemplatePath] = useState("");
  const [outputPath, setOutputPath] = useState("");

  const [startNumber, setStartNumber] = useState("");
  const [endNumber, setEndNumber] = useState("");

  const [docScope, setDocScope] = useState("whole");
  //const [sectionName, setSectionName] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  
    /* 🔥 SECTIONS FROM DB */
  const [sections, setSections] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [sectionsLoading, setSectionsLoading] = useState(true);


  /* ================= FETCH SECTIONS ================= */
  useEffect(() => {
    const loadSections = async () => {
      try {
        const data = await fetchDocumentSections();
		//console.log("SECTIONS: ",data);
        setSections(data);
      } catch (err) {
        console.error("SECTION FETCH ERROR:", err);
      } finally {
        setSectionsLoading(false);
      }
    };

    loadSections();
  }, []);
  
  
  const validate = () => {
    const err = {};

    if (!inputFile) err.inputFile = "Input file is required";
    if (!templateFile) err.templateFile = "Template file is required";

    if (!startNumber) err.startNumber = "Start number is required";
    if (!endNumber) err.endNumber = "End number is required";

    if (Number(startNumber) > Number(endNumber)) {
      err.range = "Start number must be less than or equal to End number";
    }

    if (docScope === "section" && selectedSections.length === 0) {
      err.sectionName = "Please select at least one section";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleStart = () => {
    if (!validate()) return;
    setShowPreview(true);
  };

  const confirmStart = async (e) => {
  e.preventDefault();

  setShowPreview(false);

  const formData = new FormData();

  formData.append("input_file", inputFile);
  formData.append("template_file", templateFile);
  formData.append("start_number", startNumber);
  formData.append("end_number", endNumber);

  formData.append(
    "document_section",
    docScope === "whole"
      ? "Whole Document"
      : JSON.stringify(selectedSections)
  );

  formData.append(
    "draft_type",
    docScope === "whole"
      ? "Create"
      : "Update"
  );

  formData.append(
    "sections",
    JSON.stringify(selectedSections)
  );

  let navUrl = "/";

  try {

    setLoading(true);

    const res = await createDraftJob(formData);

    //console.log("RES....",res);

    const role = localStorage.getItem("user");

    let userRole = "";

    if (role) {

      const roleObj = JSON.parse(role);

      userRole = roleObj.role;
    }

    if (userRole === "User") {

      navUrl = `/user/draft-status/${res.job_batch_id}`;

    } else {

      navUrl = `/admin/draft-status/${res.job_batch_id}`;
    }

    //onJobCreated(res.job_id);

    onClose();

    navigate(`${navUrl}`);

  } catch (err) {

    // Do not show blocking alert. Surface the error inline in the modal.
    setErrors((prev) => ({ ...prev, general: err.message || "Failed to create draft" }));

  } finally {

    setLoading(false);
  }
};
  
  // const confirmStart = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
	// 	formData.append("input_file", inputFile);
	// 	formData.append("template_file", templateFile);
	// 	formData.append("start_number", startNumber);
	// 	formData.append("end_number", endNumber);
	// 	formData.append("document_section", docScope === "whole" ? "Whole Document" : JSON.stringify(selectedSections));
	// 	formData.append("draft_type", docScope === "whole" ? "Create" : "Update");
	// 	formData.append("sections", JSON.stringify(selectedSections));
	
	// let navUrl = "/";
  //   try {
  //     setLoading(true);
  //     const res = await createDraftJob(formData);
	//   //console.log("RES....",res);
	  
	//   const role = localStorage.getItem("user");
	//   let userRole = "";
	//   if (role) {
	// 	  const roleObj = JSON.parse(role);
	// 	  userRole = roleObj.role;
	//   }
	  
	//   if (userRole === "User"){
	// 	  navUrl = `/user/draft-status/${res.job_batch_id}`;
	//   } else {
	// 	  navUrl = `/admin/draft-status/${res.job_batch_id}`;
	//   }
  //     //onJobCreated(res.job_id);
  //   } catch (err) {
  //     alert(err.message);
  //   } finally {
  //     setLoading(false);
  //   }

  //   setShowPreview(false);
  //     onClose();
  // navigate(`${navUrl}`);
  // };

  return (
    <div className="modal-backdrop">
      <div className="draft-card">
        <div className="modal-header">
          <h3>✏️ Draft Creator</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        {errors.general && (
          <div style={{ padding: "0 16px" }}>
            <p className="error">{errors.general}</p>
          </div>
        )}

        {/* INPUT FILE */}
        <label>Input File *</label>
        <div className="file-row">
          <input type="file" accept=".xlsx" required onChange={e => setInputFile(e.target.files[0])} />
        </div>
        {errors.inputFile && <p className="error">{errors.inputFile}</p>}
		
		{/* START NUMBER & END NUMBER */}
        <div className="row">
          <div>
            <label>Start Number *</label>
            <input type="number" value={startNumber} onChange={e => { setStartNumber(e.target.value); setErrors((prev) => ({ ...prev, general: undefined })); }} />
          </div>
          <div>
            <label>End Number *</label>
            <input type="number" value={endNumber} onChange={e => { setEndNumber(e.target.value); setErrors((prev) => ({ ...prev, general: undefined })); }} />
          </div>
        </div>
        {errors.range && <p className="error">{errors.range}</p>}

        {/* TEMPLATE FILE */}
        <label>Template File *</label>
        <div className="file-row">
          <input type="file" accept=".docx" required onChange={e => setTemplateFile(e.target.files[0])} />
        </div>
        {errors.templateFile && <p className="error">{errors.templateFile}</p>}

        {/* DOCUMENT SCOPE */}
        <label>Document Scope *</label>
        <div className="scope-row">
          <label>
            <input type="radio" checked={docScope === "whole"} onChange={() => setDocScope("whole")} />
            Whole Document
          </label>
          <label>
            <input type="radio" checked={docScope === "section"} onChange={() => setDocScope("section")} />
            Particular Section
          </label>
        </div>

        {/* SECTIONS */}
        {docScope === "section" && (
          <>
            <label>Sections *</label>

            {sectionsLoading ? (
              <p>Loading sections...</p>
            ) : (
              <div className="checkbox-group">
                {sections.map((sec) => (
                  <label key={sec.id} className="section-item">
                    <input
                      type="checkbox"
                      checked={selectedSections.some(
                        (s) => s.id === sec.id
                      )}
                      onChange={(e) =>
                        e.target.checked
                          ? setSelectedSections([
                              ...selectedSections,
                              sec,
                            ])
                          : setSelectedSections(
                              selectedSections.filter(
                                (s) => s.id !== sec.id
                              )
                            )
                      }
                    />
                    {sec.name}
                  </label>
                ))}
              </div>
            )}
            {errors.sections && (
              <p className="error">{errors.sections}</p>
            )}
          </>
        )}


        <button className="start-btn" onClick={handleStart} disabled={loading || !!errors.general}>
          {loading ? "Processing..." : "Start"}
        </button>

        {showPreview && (
          <div className="preview-modal">
            <div className="preview-box">
              <h4>Preview</h4>
              <p><b>Input File:</b> {inputFile.name}</p>
              <p><b>Template File:</b> {templateFile.name}</p>
              <p><b>Range:</b> {startNumber} → {endNumber}</p>
              <p><b>Scope:</b> {docScope === "whole" ? "Whole Document" : selectedSections.map(s => s.name).join("; ")}</p>

              <div className="preview-actions">
                <button onClick={() => setShowPreview(false)}>Cancel</button>
                <button className="confirm" onClick={confirmStart}>Confirm</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DraftCreator;
